(() => {
  const redirects = {
    "/group-profile": "/pages/group-profile",
    "/group-business": "/pages/group-business",
    "/global-network": "/pages/global-network",
    "/contact": "/pages/contact",
    "/brand-story": "/pages/brand-story",
    "/environmental-association": "/pages/environmental-association",
    "/green-coffee-trade": "/pages/green-coffee-trade",
    "/group-updates": "/pages/group-updates",
    "/h350": "/pages/h350",
    "/papua-new-guinea": "/pages/papua-new-guinea",
    "/company/hong-kong": "/pages/company-hong-kong",
    "/company/papua-new-guinea": "/pages/company-papua-new-guinea",
    "/company/canada": "/pages/company-canada",
    "/company/china": "/pages/company-china",
    "/roasted-coffee/morning-mist": "/pages/roasted-coffee-morning-mist",
    "/roasted-coffee/rosewood-light": "/pages/roasted-coffee-rosewood-light",
    "/roasted-coffee/highland-crimson": "/pages/roasted-coffee-highland-crimson",
    "/roasted-coffee/volcanic-reserve": "/pages/roasted-coffee-volcanic-reserve",
  };
  const languages = ["en", "zh", "fr", "es"];
  const documentLanguages = { en: "en", zh: "zh-Hans", fr: "fr", es: "es" };
  const menuLabels = {
    en: { open: "Menu", close: "Close" },
    zh: { open: "菜单", close: "关闭" },
    fr: { open: "Menu", close: "Fermer" },
    es: { open: "Menú", close: "Cerrar" },
  };
  const assets = window.__libergeonAssets || {};
  let currentLanguage = "en";

  const fixed = (value) => {
    if (!value) return value;
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin) return value;
      if (url.pathname === "/_next/image") {
        const raw = url.searchParams.get("url");
        if (raw && assets[raw]) return assets[raw];
      }
      return assets[url.pathname] || value;
    } catch {
      return value;
    }
  };

  const repairElement = (element) => {
    for (const attribute of ["src", "poster"]) {
      const value = element.getAttribute?.(attribute);
      const next = fixed(value);
      if (value && next !== value) element.setAttribute(attribute, next);
    }
    const srcset = element.getAttribute?.("srcset");
    if (srcset) {
      const next = srcset
        .split(",")
        .map((candidate) => {
          const parts = candidate.trim().split(/\s+/);
          parts[0] = fixed(parts[0]);
          return parts.join(" ");
        })
        .join(", ");
      if (next !== srcset) element.setAttribute("srcset", next);
    }
  };

  const repairTree = (root) => {
    if (root.nodeType === 1) repairElement(root);
    root.querySelectorAll?.("img[src],source[src],video[poster],[srcset]").forEach(repairElement);
  };

  const setMenuState = (button, open) => {
    const navigation = document.getElementById(button.getAttribute("aria-controls"));
    if (!navigation) return;
    navigation.classList.toggle("nav--open", open);
    button.setAttribute("aria-expanded", String(open));
    button.textContent = menuLabels[currentLanguage][open ? "close" : "open"];
  };

  const applyLanguage = (language, preserveScroll = false) => {
    if (!languages.includes(language)) return false;
    const template = document.querySelector(`template[data-libergeon-language="${language}"]`);
    const currentMain = document.querySelector("main");
    const nextMain = template?.content.querySelector("main")?.cloneNode(true);
    if (!currentMain || !nextMain) return false;
    const scrollY = window.scrollY;
    currentMain.replaceWith(nextMain);
    currentLanguage = language;
    localStorage.setItem("libergeon-language", language);
    document.documentElement.lang = documentLanguages[language];
    nextMain.querySelectorAll(".language-switcher button").forEach((button, index) => {
      const active = languages[index] === language;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", String(active));
    });
    repairTree(nextMain);
    if (preserveScroll) {
      requestAnimationFrame(() => window.scrollTo(0, Math.min(scrollY, document.documentElement.scrollHeight - innerHeight)));
    } else {
      window.scrollTo(0, 0);
    }
    return true;
  };

  const initialize = () => {
    repairTree(document);
    const savedLanguage = localStorage.getItem("libergeon-language");
    if (languages.includes(savedLanguage) && savedLanguage !== "en") {
      applyLanguage(savedLanguage);
    } else {
      currentLanguage = "en";
      document.documentElement.lang = "en";
    }
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes") repairElement(mutation.target);
      mutation.addedNodes.forEach(repairTree);
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["src", "srcset", "poster"],
  });

  document.addEventListener("click", (event) => {
    const languageButton = event.target.closest?.(".language-switcher button");
    if (languageButton) {
      const buttons = [...languageButton.parentElement.querySelectorAll("button")];
      const language = languages[buttons.indexOf(languageButton)];
      if (language) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyLanguage(language, true);
      }
      return;
    }

    const menuButton = event.target.closest?.(".menu-toggle");
    if (menuButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setMenuState(menuButton, menuButton.getAttribute("aria-expanded") !== "true");
      return;
    }

    const anchor = event.target.closest?.("a");
    if (!anchor) return;
    const menu = anchor.closest("nav.nav--open");
    if (menu) {
      const button = document.querySelector(`.menu-toggle[aria-controls="${menu.id}"]`);
      if (button) setMenuState(button, false);
    }
    const url = new URL(anchor.href, location.href);
    const destination = url.origin === location.origin ? redirects[url.pathname] : null;
    if (!destination) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(`${destination}${url.search}${url.hash}`);
  }, true);

  document.addEventListener("submit", (event) => {
    if (event.target.closest?.("main")) event.preventDefault();
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
})();
